import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { AppStoreProvider, useStore } from './store/AppStore'
import { PlayerProvider } from './store/PlayerContext'
import { I18nProvider } from './i18n'
import './styles/app.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

/** Language lives in settings, so the provider has to sit inside the store. */
function Localised() {
  const { state } = useStore()
  return (
    <I18nProvider lang={state.settings.lang}>
      <PlayerProvider>
        <App />
      </PlayerProvider>
    </I18nProvider>
  )
}

createRoot(root).render(
  <StrictMode>
    <AppStoreProvider>
      <Localised />
    </AppStoreProvider>
  </StrictMode>,
)
